import { render, staticRenderFns } from "./form_detail_products_component.vue?vue&type=template&id=46b53d1e&scoped=true"
import script from "./form_detail_products_component.vue?vue&type=script&lang=js"
export * from "./form_detail_products_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_products_component.vue?vue&type=style&index=0&id=46b53d1e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b53d1e",
  null
  
)

export default component.exports